/* eslint-disable no-undefined */
import React, { createContext, useCallback, useContext, useState } from 'react';

export const initialState = {
	open: false,
	message: '',
	severity: '',
};

const AlertStateContext = createContext(initialState);
const AlertUpdaterContext = createContext();

function useAlertState() {
	const alert = useContext(AlertStateContext);

	if (alert === undefined) {
		throw new Error('useAlertState must be used within a AlertProvider');
	}

	return alert;
}

function useAlertUpdater() {
	const setAlert = useContext(AlertUpdaterContext);

	if (setAlert === undefined) {
		throw new Error('useAlertUpdater must be used within a AlertProvider');
	}

	const alert = useCallback(
		({ message, severity }) => setAlert({ open: true, message, severity }),
		[setAlert],
	);

	const onClose = useCallback(() => setAlert({ open: false }), [setAlert]);

	return { alert, onClose };
}

function AlertProvider({ state = initialState, children }) {
	const [alert, setAlert] = useState(state);

	return (
		<AlertStateContext.Provider value={alert}>
			<AlertUpdaterContext.Provider value={setAlert}>{children}</AlertUpdaterContext.Provider>
		</AlertStateContext.Provider>
	);
}

export { AlertProvider, useAlertState, useAlertUpdater };
